import { createContext } from 'react'

import { LumiContextValue } from './LumiContext.types'

export const LumiContext = createContext<LumiContextValue | undefined>(undefined)
